import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  Modal,
  HeadingDisplay,
  ContentDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocation/helpers';

interface IData {
  updatedAt: string;
  dayTradeBalance: string;
  variation: { formatted: string; value: number; fontStyle: string };
}

interface Props {
  isOpen: boolean;
  data: IData;
  step: EMarginAllocationSteps;
}
interface EmitEvents {
  (event: 'close'): void;
  (event: 'continue', step: EMarginAllocationSteps): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmEditModal',
  props: {
    isOpen: { type: Boolean },
    data: null,
    step: null
  },
  emits: ["close", "continue"],
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  data: IData;
  step: EMarginAllocationSteps;
}





const subtitle = computed(() => {
  return props.data.variation.value < 0
    ? 'Prejuízos influenciam na realocação de limites.'
    : '';
});

const variationColor = computed(() => {
  switch (props.data.variation.fontStyle) {
    case 'GREEN':
      return NebraskaColors.monetaryPositive;

    case 'RED':
      return NebraskaColors.monetaryNegative;

    default:
      return NebraskaColors.elementPrimary;
  }
});

return { __sfc: true,props, subtitle, variationColor, Modal, HeadingDisplay, ContentDisplay, ListDisplay, ButtonContainer, ButtonPrimary, ButtonSecondary, Portal }
}

})